import * as XLSX from 'xlsx';

// Materials import: the tenant's spreadsheet AS IS, mapped onto canonical attribute keys by the
// PACK's import_map (data on engine_packs.doc_template — supporting a new customer's layout is a
// jsonb update, never a deploy). Header matching is by fragment, case-insensitive, because real
// headers read like "Calories (kcal/100g)". An unmatched cell is simply absent — the compute
// layer will call it unrecorded; nothing here invents a zero.

export async function parseMaterialsXlsx(file, importMap) {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: 'array' });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const grid = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: null });
  if (!grid.length) return { rows: [], skipped: 0 };

  const headers = (grid[0] || []).map((h) => String(h ?? '').trim());
  const findCol = (fragment) => headers.findIndex(
    (h) => h.toLowerCase().includes(String(fragment).toLowerCase()),
  );
  const codeCol = (importMap?.code_headers || ['code']).map(findCol).find((i) => i >= 0) ?? -1;
  const nameCol = (importMap?.name_headers || ['name']).map(findCol).find((i) => i >= 0) ?? -1;
  const attrCols = Object.entries(importMap?.attr_headers || {})
    .map(([key, fragment]) => [key, findCol(fragment)])
    .filter(([, i]) => i >= 0);

  const rows = [];
  let skipped = 0;
  for (const line of grid.slice(1)) {
    const code = String(line[codeCol] ?? '').trim();
    // Material codes look like R002/W001; anything else on the sheet (labels, spacer rows,
    // section titles) is not a material and is counted rather than half-imported.
    if (!/^[A-Za-z]\d{2,4}$/.test(code)) { skipped += 1; continue; }
    const attrs = {};
    for (const [key, col] of attrCols) {
      const v = line[col];
      attrs[key] = (v === null || v === undefined) ? '' : v;
    }
    rows.push({
      code,
      display_name: String(line[nameCol] ?? code).trim() || code,
      attrs,
    });
  }
  return { rows, skipped };
}
